import React, { useEffect, useMemo } from 'react';
import VideoTranscript from '../../components/VideoTranscript/index';
import { WTitle } from '../../components/Widget';
import Person from '../../../../../../assets/finance/topic1600/section0-bg1.png';
import Light from '../../../../../../assets/finance/topic1600/section0-bg2.png';
import { useStore } from '../../../../store';
import { useParams } from 'react-router-dom';

interface ISection0Props {
  settings: any;
}

const Section0: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[0],
    [settings?.paragraphs]
  );
  const ID = '1';
  React.useEffect(() => {
    const onPlay = () => {
      if (process.env.REACT_APP_HOST_TYPE === 'dev') {
        return;
      }
      const elem = document?.querySelector('#video1600') as any;
      if (elem?.requestFullscreen) {
        elem.requestFullscreen().catch((err: any) => console.log(err));
      } else if (elem?.webkitEnterFullscreen) {
        try {
          elem.webkitEnterFullscreen();
        } catch (error) {
          console.log(error);
        }
      }
      document
        ?.querySelector('#video1600')
        ?.removeEventListener('play', onPlay);
    };
    document?.querySelector('#video1600')?.removeEventListener('play', onPlay);
    document
      ?.querySelector('#video1600')
      ?.addEventListener('play', onPlay, { passive: true });
    return () =>
      document
        ?.querySelector('#video1600')
        ?.removeEventListener('play', onPlay);
  }, []);
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { updateParagraphState } = useStore();
  useEffect(() => {
    updateParagraphState(p_course, p_topic, ID, 'completed', []);
  }, []);
  return (
    <div className="course-landing">
      <div className="course-landing-content">
        <WTitle title={paragraphsSettings?.header} />
        <div className="description">{paragraphsSettings.description}</div>
        <div className="course-landing-text">
          <img className="person" src={Person} alt="" />
          <div className="course-box">
            <div className="video-container">
              <video
                id="video1600"
                width="100%"
                controls
                playsInline
                autoPlay={process.env.REACT_APP_HOST_TYPE !== 'dev'}
              >
                <source
                  src={paragraphsSettings?.landingVideo?.src}
                  type="video/mp4"
                />
                Your browser does not support HTML video.
              </video>
              <VideoTranscript transcripts={paragraphsSettings.transcripts} />
            </div>
            <img className="light" src={Light} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section0;
